<template lang="pug">
  main
    NavBarUsuarios
    Loader(v-show="isLoading")
    section.hero(v-show="!isLoading")
      .container
        .content.has-text-centered
          h3.title Nuevo usuario
          .columns
            .column.is-12-tablet.is-full-mobile
              .card
                .card-content
                  .columns.is-vcentered
                    .column.is-2
                      .field
                        label.label Usuario
                        .control.has-icons-left
                          input.input.is-primary(
                            type='text', 
                            placeholder='Usuario',
                            v-model="user.nombre"
                          )
                          .icon.is-small.is-left
                            i.fas.fa-user
                    .column.is-5
                      .field
                        label.label Nombre Completo
                        .control.has-icons-left
                          input.input.is-primary(
                            type='text', 
                            placeholder='Nombre Completo',
                            v-model="user.nombre_completo"
                          )
                          .icon.is-small.is-left
                            i.fas.fa-signature
                    .column.is-2
                      .field
                        label.label Contraseña
                        .control.has-icons-left
                          input.input.is-primary(
                            type='password', 
                            placeholder='Contraseña',
                            v-model="user.password"
                          )
                          .icon.is-small.is-left
                            i.fas.fa-key
                    .column.is-2
                      .field
                        label.label Confirmar Password
                        .control.has-icons-left
                          input.input.is-primary(
                            type='password', 
                            placeholder='Confirmar Contraseña',
                            v-model="user.password_confirm"
                          )
                          .icon.is-small.is-left
                            i.fas.fa-check
                    .column.is-1
                      span(v-html="resultConfirm()")
                  .columns
                    .column.is-4
                      .field
                        label.label Categoría
                        .control.has-icons-left
                          .select.is-primary.is-rounded
                            select(v-model="user.categoria")
                              option(value="" checked) Seleccione una Categoría
                              option(v-for="cat in categorias" :key="cat.valor" :value="cat.valor") {{ cat.nombre }}
                          .icon.is-small.is-left
                            i.fas.fa-tag
                    .column.is-4
                      .field
                        label.label Departamento
                        .control.has-icons-left
                          .select.is-primary.is-rounded
                            select(v-model="user.departamento")
                              option(value="" checked) Seleccione una Departamento
                              option(v-for="dep in departamentos" :key="dep.valor" :value="dep.valor") {{ dep.nombre }}
                          .icon.is-small.is-left
                            i.fas.fa-address-card
                    .column.is-4
                      .field
                        label.label Cargo
                        .control.has-icons-left
                          .select.is-primary.is-rounded
                            select(v-model="user.cargo")
                              option(value="" checked) Seleccione un Cargo
                              option(v-for="cargo in cargosSelected" :key="cargo.valor" :value="cargo.valor") {{ cargo.nombre }}
                          .icon.is-small.is-left
                            i.fas.fa-tag
                  .columns
                    .column.is-4
                      .field
                        label.label E-mail
                        .control.has-icons-left
                          input.input.is-primary(
                            type='email', 
                            placeholder='E-mail',
                            v-model="user.email"
                          )
                          .icon.is-small.is-left
                            i.far.fa-envelope
                    .column.is-4
                      .field
                        label.label Ubicación
                        .control.has-icons-left
                          .select.is-primary.is-rounded
                            select(v-model="user.ubicacion")
                              option(value="" checked) Seleccione una Ubicación
                              option(v-for="ubi in ubicaciones" :key="ubi.valor" :value="ubi.valor") {{ ubi.nombre }}
                          .icon.is-small.is-left
                            i.fas.fa-map-pin
                    .column.is-4
                      .field
                        label.label Oficina
                        .control.has-icons-left
                          .select.is-primary.is-rounded
                            select(v-model="user.oficina")
                              option(value="" checked) Seleccione una Ubicación
                              option(v-for="ofi in oficinasSel" :key="ofi.id" :value="ofi.id") {{ ofi.nombre }}
                          .icon.is-small.is-left
                            i.fas.fa-map-pin
                  .columns
                    .column.is-2
                      button.button.is-primary.is-fullwidth(:disabled="isDisabled" @click="guardarUsuario") Registrar
                    .column.is-2
                      router-link.a.button.is-default.is-fullwidth(to="/Usuarios") Cancelar
        .columns.column-blanco
</template>


<script>
  import usuariosServices from '@/services/usuarios/usuarios'
  import NavBarUsuarios from '@/components/usuarios_Componentes/layout/NavBarUsuarios.vue'
  import Loader from '@/components/shared/Loader.vue'
  import moment from 'moment'
  export default {
    name: 'usuario_Nuevo',
    components: { NavBarUsuarios, Loader },
    data () {
      return {
        user: {
          id: '',
          nombre: '',
          nombre_completo: '',
          nombre_file: '',
          password: '',
          password_confirm: '',
          categoria: '',
          departamento: '',
          cargo: '',
          jefe: '',
          ubicacion: '',
          fechaReg: '',
          email: '',
          firma: ''
        },
        tieneDatos: false,
        isLoading: true,
        categorias: [
          { nombre: 'Gerencia', valor: '0'},
          { nombre: 'Asistente', valor: '1'},
          { nombre: 'Jefe Área', valor: '2'},
          { nombre: 'Empleado', valor: '3'},
          { nombre: 'Instalación', valor: '4'},
          { nombre: 'Pasante', valor: '5'},
          { nombre: 'Externo', valor: '8'},
          { nombre: 'Público', valor: '9'}
        ],
        departamentos: [
          { nombre: 'GERENCIA', valor: '0'},
          { nombre: 'INSTRUMENTACION', valor: '1'},
          { nombre: 'ADMINISTRACIÓN', valor: '2'},
          { nombre: 'CONTRALORIA', valor: '21'},
          { nombre: 'CONTABILIDAD', valor: '22'},
          { nombre: 'CUENTAS POR PAGAR', valor: '23'},
          { nombre: 'FISCAL', valor: '24'},
          { nombre: 'LEGAL', valor: '25'},
          { nombre: 'SEGUIMIENTO AMB.', valor: '71'},
          { nombre: 'REGULACIÓN', valor: '72'},
          { nombre: 'PROCESOS Y PROCED.', valor: '73'},
          { nombre: 'SISTEMAS Y TELEC.', valor: '3'},
          { nombre: 'OPERACIONES', valor: '4'},
          { nombre: 'MANTENIMIENTO', valor: '5'},
          { nombre: 'INSTRUMENTACIÓN & SISTEMAS', valor: '6'},
          { nombre: 'SEGURIDAD', valor: '7'},
          { nombre: 'EXTERNO', valor: '8'},
          { nombre: 'PÚBLICO', valor: '9'}
        ],
        cargos: [
          { nombre: 'GERENTE GENERAL', valor: '000', parent: '0'},
          { nombre: 'GERENTE PLANTA', valor: '001', parent: '0'},
          { nombre: 'GERENTE ADMINISTRACIÓN', valor: '002', parent: '0'},
          { nombre: 'GERENTE GIA', valor: '003', parent: '0'},

          { nombre: 'GERENTE DE CONTRALORIA', valor: '2100', parent: '21'},
          { nombre: 'ASISTENTE FINANZAS', valor: '2120', parent: '21'},

          { nombre: 'CONTADOR GENERAL', valor: '2200', parent: '22'},
          { nombre: 'CONTADOR SR.', valor: '2220', parent: '22'},

          { nombre: 'TESORERÍA', valor: '2300', parent: '23'},
          { nombre: 'ANALISTA CUENTAS P.P.', valor: '2320', parent: '23'},
          { nombre: 'AUXILIAR ADMINISTRATIVO', valor: '2321', parent: '23'},

          { nombre: 'FISCALISTA', valor: '2400', parent: '24'},
          { nombre: 'USUARIO FISCALISTA', valor: '2420', parent: '24'},
          { nombre: 'JEF. LEGAL', valor: '2500', parent: '25'},
          { nombre: 'USUARIO LEGAL', valor: '2520', parent: '25'},


          { nombre: 'SEGUIMIENTO AMB.', valor: '7100', parent: '71'},
          { nombre: 'AUXILIAR AMBIENTAL', valor: '7130', parent: '71'},
          
          { nombre: 'GERENTE DE REGULACIÓN', valor: '7200', parent: '72'},
          { nombre: 'AUXILIAR DE REGULACIÓN', valor: '7230', parent: '72'},
          { nombre: 'ING. DE PROCESOS Y PROCED.', valor: '7300', parent: '73'},
          { nombre: 'ASISTENTE GERENCIA', valor: '120', parent: '2'},
          { nombre: 'ASISTENTE INST. & SIST.', valor: '160', parent: '6'},
          { nombre: 'JEFE INSTRUMENTACIÓN', valor: '210', parent: '1'},
          { nombre: 'JEFE ADMINISTRACIÓN', valor: '220', parent: '2'},
          { nombre: 'JEFE SISTEMAS Y TELEC.', valor: '230', parent: '3'},
          { nombre: 'JEFE OPERACIONES', valor: '240', parent: '4'},
          { nombre: 'JEFE ESTACIÓN', valor: '241', parent: '4'},
          { nombre: 'JEFE MANTENIMIENTO', valor: '250', parent: '5'},
          { nombre: 'JEFE SEGURIDAD', valor: '270', parent: '7'},
          { nombre: 'EMPLEADO ADMÓN.', valor: '300', parent: '0'},
          { nombre: 'EMPLEADO INSTRUMENTACIÓN', valor: '310', parent: '1'},
          { nombre: 'EMPLEADO ADMINISTRACIÓN', valor: '320', parent: '2'},
          { nombre: 'EMPLEADO DE ADUANA', valor: '321', parent: '2'},
          { nombre: 'AUDITOR OPERATIVO', valor: '323', parent: '2'},
          { nombre: 'AUDITOR JUNIOR', valor: '324', parent: '2'},
          { nombre: 'INSTALACIÓN', valor: '429', parent: '2'},
          { nombre: 'EMPLEADO SISTEMAS', valor: '330', parent: '3'},
          { nombre: 'ALMACENISTA GIA', valor: '331', parent: '3'},
          { nombre: 'ALMACENISTA USUARIO', valor: '332', parent: '3'},
          { nombre: 'PASANTE SISTEMAS', valor: '530', parent: '3'},
          { nombre: 'PASANTE INSTRUMENTACIÓN', valor: '410', parent: '1'},
          { nombre: 'EMPLEADO OPERACIONES', valor: '340', parent: '4'},
          { nombre: 'EMPLEADO FACTURACIÓN', valor: '341', parent: '4'},
          { nombre: 'EMPLEADO BÁSCULA', valor: '342', parent: '4'},
          { nombre: 'EMPLEADO BÁSCULA y FACT.', valor: '343', parent: '4'},
          { nombre: 'OPIB', valor: '344', parent: '4'},
          { nombre: 'EMPLEADO MANTENIMIENTO', valor: '350', parent: '5'},
          { nombre: 'EMPLEADO SEGURIDAD', valor: '370', parent: '7'},
          { nombre: 'USUARIO PROPANGOL', valor: '880', parent: '8'},
          { nombre: 'USUARIO MOVENERGY', valor: '881', parent: '8'},
          { nombre: 'USUARIO NIETO', valor: '882', parent: '8'},
          { nombre: 'USUARIO METROPOLITANO', valor: '883', parent: '8'},
          { nombre: 'USUARIO URIBE', valor: '884', parent: '8'},
          { nombre: 'USUARIO MABARAK', valor: '885', parent: '8'},
          { nombre: 'USUARIO SONIGAS', valor: '886', parent: '8'},
          { nombre: 'JEFE OF. PROPANGOL', valor: '880', parent: '8'},
          { nombre: 'Monitor Movenergy', valor: '889', parent: '8'},
          { nombre: 'USUARIO PÚBLICO', valor: '990', parent: '9'},
        ],
        cargosSelected: [],
        ubicaciones: [
          { nombre: 'IRGE', valor: 'IRGE' },
          { nombre: 'TPA', valor: 'TPA' },
          { nombre: 'CORPORATIVO', valor: 'CORP' },
          { nombre: 'DUCTO', valor: 'LPGD' },
          { nombre: 'EB00', valor: 'EB00' },
          { nombre: 'EB01', valor: 'EB01' },
          { nombre: 'EB02', valor: 'EB02' },
          { nombre: 'EB03', valor: 'EB03' },
          { nombre: 'EB04', valor: 'EB04' },
          { nombre: 'ERM-TLAUTLA', valor: 'ERM' },
          { nombre: 'REMOTO', valor: 'REM' },
        ],
        oficinas: [
          { 'id': 'TPA-ALM', 'nombre': 'Almacén', 'source': 'TPA' },
          { 'id': 'TPA-ALS', 'nombre': 'Almacén Sist.', 'source': 'TPA' },
          { 'id': 'TPA-ADM', 'nombre': 'Of. Admin.', 'source': 'TPA' },
          { 'id': 'TPA-CC', 'nombre': 'Cuarto de Control', 'source': 'TPA' },
          { 'id': 'TPA-SERV', 'nombre': 'Servidores', 'source': 'TPA' },
          { 'id': 'TPA-IO', 'nombre': 'Cuarto de IOS', 'source': 'TPA' },
          { 'id': 'TPA-FAC', 'nombre': 'Facturación', 'source': 'TPA' },
          { 'id': 'TPA-BAS', 'nombre': 'Báscula', 'source': 'TPA' },
          { 'id': 'TPA-GER', 'nombre': 'Gerencia', 'source': 'TPA' },
          { 'id': 'TPA-MUE', 'nombre': 'Muelle', 'source': 'TPA' },
          { 'id': 'TPA-MANT', 'nombre': 'Subgerencia de Mntto.', 'source': 'TPA' },
          { 'id': 'TPA-TALL', 'nombre': 'Taller de Mntto.', 'source': 'TPA' },
          { 'id': 'TPA-SEG', 'nombre': 'Subgerencia de Seguridad', 'source': 'TPA' },
          { 'id': 'TPA-SADM', 'nombre': 'Subgerencia Administrativa', 'source': 'TPA' },
          { 'id': 'TPA-PROP', 'nombre': 'Of. Propangol', 'source': 'TPA' },
          { 'id': 'TPA-NIE', 'nombre': 'Of. Nieto', 'source': 'TPA' },
          { 'id': 'TPA-MOV', 'nombre': 'Of. Movenergy', 'source': 'TPA' },
          { 'id': 'TPA-SJ', 'nombre': 'Sala de Juntas', 'source': 'TPA' },
          { 'id': 'TPA-ACC', 'nombre': 'Accesos', 'source': 'TPA' },
          { 'id': 'TPA-VIG', 'nombre': 'Vigilancia', 'source': 'TPA' },
          { 'id': 'TPA-ESF', 'nombre': 'Esféricos', 'source': 'TPA' },
          { 'id': 'TPA-LLEN', 'nombre': 'Llenaderas', 'source': 'TPA' },
          { 'id': 'TPA-SJ2', 'nombre': 'Sala de Juntas 2', 'source': 'TPA' },
          { 'id': 'TPA-REC', 'nombre': 'Recepción', 'source': 'TPA' },
          { 'id': 'TPA-COM', 'nombre': 'Comedor', 'source': 'TPA' },
          { 'id': 'TPA-SALM', 'nombre': 'SubAlmacén', 'source': 'TPA' },
          { 'id': 'TPA-TRE', 'nombre': 'Área 300', 'source': 'TPA' },
          { 'id': 'IRGE-ALM', 'nombre': 'Almacén', 'source': 'IRGE' },
          { 'id': 'IRGE-ADM', 'nombre': 'Of. Admin.', 'source': 'IRGE' },
          { 'id': 'IRGE-CC', 'nombre': 'Cuarto de Control', 'source': 'IRGE' },
          { 'id': 'IRGE-FAC', 'nombre': 'Facturación', 'source': 'IRGE' },
          { 'id': 'IRGE-BAS', 'nombre': 'Báscula', 'source': 'IRGE' },
          { 'id': 'IRGE-GER', 'nombre': 'Gerencia', 'source': 'IRGE' },
          { 'id': 'IRGE-GADM', 'nombre': 'Gerencia Admn.', 'source': 'IRGE' },
          { 'id': 'IRGE-SJ', 'nombre': 'Sala de Juntas', 'source': 'IRGE' },
          { 'id': 'IRGE-SEG', 'nombre': 'Of. Seguridad', 'source': 'IRGE' },
          { 'id': 'IRGE-IOS', 'nombre': 'Cuarto de IOS', 'source': 'IRGE' },
          { 'id': 'IRGE-PEM', 'nombre': 'Of. Pemex', 'source': 'IRGE' },
          { 'id': 'IRGE-ACC', 'nombre': 'Accesos', 'source': 'IRGE' },
          { 'id': 'IRGE-VIG', 'nombre': 'Vigilancia', 'source': 'IRGE' },
          { 'id': 'IRGE-CE', 'nombre': 'Cuarto Eléctrico', 'source': 'IRGE' },
          { 'id': 'IRGE-REC', 'nombre': 'Recepción', 'source': 'IRGE' },
          { 'id': 'IRGE-OP', 'nombre': 'Operación', 'source': 'IRGE' },
          { 'id': 'IRGE-CCP', 'nombre': 'Cuarto Control Plus', 'source': 'IRGE' },
          { 'id': 'IRGE-VP', 'nombre': '23 Puntos', 'source': 'IRGE' },
          { 'id': 'IRGE-MOV', 'nombre': 'Movenergy', 'source': 'IRGE' },
          { 'id': 'IRGE-VIC', 'nombre': 'Vigilanca CUSAEM', 'source': 'IRGE' },
          { 'id': 'IRGE-OFE', 'nombre': 'Oficina Eléctrica', 'source': 'IRGE' },
          { 'id': 'EB04-ALG', 'nombre': 'Almacén S & I', 'source': 'EB04' },
          { 'id': 'EB04-CC', 'nombre': 'Cuarto de Control', 'source': 'EB04' },
          { 'id': 'EB04-ADM', 'nombre': 'Of. Admin.', 'source': 'EB04' },
          { 'id': 'EB04-GER', 'nombre': 'Gerencia', 'source': 'EB04' },
          { 'id': 'EB04-SIS', 'nombre': 'Sistemas', 'source': 'EB04' },
          { 'id': 'EB04-INS', 'nombre': 'Instrumentación', 'source': 'EB04' },
          { 'id': 'EB04-VIG', 'nombre': 'Vigilancia', 'source': 'EB04' },
          { 'id': 'EB04-SG', 'nombre': 'Sala de Juntas', 'source': 'EB04' },
          { 'id': 'EB04-TIA', 'nombre': 'Taller Inst/Aut', 'source': 'EB04' },
          { 'id': 'EB04-ALM', 'nombre': 'Almacén', 'source': 'EB04' },
          { 'id': 'EB03-CC', 'nombre': 'Cuarto de Control', 'source': 'EB03' },
          { 'id': 'EB03-ADM', 'nombre': 'Of. Admin.', 'source': 'EB03' },
          { 'id': 'EB03-VIG', 'nombre': 'Vigilancia', 'source': 'EB03' },
          { 'id': 'EB03-ARC', 'nombre': 'Archivo', 'source': 'EB03' },
          { 'id': 'EB03-COM', 'nombre': 'Comedor', 'source': 'EB03' },
          { 'id': 'EB03-REC', 'nombre': 'Recepción', 'source': 'EB03' },
          { 'id': 'EB03-SJ', 'nombre': 'Sala de Juntas', 'source': 'EB03' },
          { 'id': 'EB03-SV', 'nombre': 'Servicios', 'source': 'EB03' },
          { 'id': 'EB03-TAL', 'nombre': 'Taller', 'source': 'EB03' },
          { 'id': 'EB03-ALM', 'nombre': 'Almacén', 'source': 'EB03' },
          { 'id': 'EB02-CC', 'nombre': 'Cuarto de Control', 'source': 'EB02' },
          { 'id': 'EB02-ADM', 'nombre': 'Of. Admin.', 'source': 'EB02' },
          { 'id': 'EB02-VIG', 'nombre': 'Vigilancia', 'source': 'EB02' },
          { 'id': 'EB02-ARC', 'nombre': 'Archivo', 'source': 'EB02' },
          { 'id': 'EB02-COM', 'nombre': 'Comedor', 'source': 'EB02' },
          { 'id': 'EB02-REC', 'nombre': 'Recepción', 'source': 'EB02' },
          { 'id': 'EB02-SJ', 'nombre': 'Sala de Juntas', 'source': 'EB02' },
          { 'id': 'EB02-ALM', 'nombre': 'Almacén', 'source': 'EB02' },
          { 'id': 'EB01-CC', 'nombre': 'Cuarto de Control', 'source': 'EB01' },
          { 'id': 'EB01-ADM', 'nombre': 'Of. Admin.', 'source': 'EB01' },
          { 'id': 'EB01-VIG', 'nombre': 'Vigilancia', 'source': 'EB01' },
          { 'id': 'EB01-ARC', 'nombre': 'Archivo', 'source': 'EB01' },
          { 'id': 'EB01-COM', 'nombre': 'Comedor', 'source': 'EB01' },
          { 'id': 'EB01-REC', 'nombre': 'Recepción', 'source': 'EB01' },
          { 'id': 'EB01-SJ', 'nombre': 'Sala de Juntas', 'source': 'EB01' },
          { 'id': 'EB01-ALM', 'nombre': 'Almacén', 'source': 'EB01' },
          { 'id': 'EB00-CC', 'nombre': 'Cuarto de Control', 'source': 'EB00' },
          { 'id': 'EB00-ADM', 'nombre': 'Of. Admin.', 'source': 'EB00' },
          { 'id': 'EB00-VIG', 'nombre': 'Vigilancia', 'source': 'EB00' },
          { 'id': 'EB00-ALM', 'nombre': 'Almacén', 'source': 'EB00' },
          { 'id': 'EB00-ARC', 'nombre': 'Archivo', 'source': 'EB00' },
          { 'id': 'EB00-COM', 'nombre': 'Comedor', 'source': 'EB00' },
          { 'id': 'EB00-SV', 'nombre': 'Servicios', 'source': 'EB00' },
          { 'id': 'ERM-CC', 'nombre': 'Cuarto de Control', 'source': 'ERM' },
          { 'id': 'ERM-ADM', 'nombre': 'Of. Admin.', 'source': 'ERM' },
          { 'id': 'ERM-VIG', 'nombre': 'Vigilancia', 'source': 'ERM' },
          { 'id': 'ERM-ALM', 'nombre': 'Almacén', 'source': 'ERM' },
          { 'id': 'VALV-ADM', 'nombre': 'Gabinete', 'source': 'LPGD' },
          { 'id': 'CORP-DIR', 'nombre': 'Dirección', 'source': 'CORP' },
          { 'id': 'CORP-GG', 'nombre': 'Gerencia Gral.', 'source': 'CORP' },
          { 'id': 'CORP-GC', 'nombre': 'Gerencia de Contraloría', 'source': 'CORP' },
          { 'id': 'CORP-C', 'nombre': 'Contabilidad', 'source': 'CORP' },
          { 'id': 'CORP-CP', 'nombre': 'Cuentas por Pagar', 'source': 'CORP' },
          { 'id': 'CORP-F', 'nombre': 'Fiscal', 'source': 'CORP' },
          { 'id': 'CORP-SA', 'nombre': 'Seguimiento Amb.', 'source': 'CORP' },
          { 'id': 'CORP-GR', 'nombre': 'Gerencia de Reg.', 'source': 'CORP' },
          { 'id': 'CORP-ALM', 'nombre': 'Almacén', 'source': 'CORP' },
          { 'id': 'CORP-ALG', 'nombre': 'Almacén GIA', 'source': 'CORP' },
          { 'id': 'CORP-GIS', 'nombre': 'Gerencia Inst. y Sist.', 'source': 'CORP' },
          { 'id': 'CORP-SIT', 'nombre': 'Site', 'source': 'CORP' },
          { 'id': 'CORP-RH', 'nombre': 'Recursos Humanos', 'source': 'CORP' },
          { 'id': 'CORP-LEG', 'nombre': 'Legal', 'source': 'CORP' },
          { 'id': 'CORP-REC', 'nombre': 'Recepción', 'source': 'CORP' },
          { 'id': 'CORP-AUD', 'nombre': 'Auditoría', 'source': 'CORP' },
          { 'id': 'CORP-TES', 'nombre': 'Tesorería', 'source': 'CORP' },
          { 'id': 'CORP-GEN', 'nombre': 'General', 'source': 'CORP' },
          { 'id': 'LPGD-V1', 'nombre': 'Válvula 1', 'source': 'LPGD' },
          { 'id': 'LPGD-V2', 'nombre': 'Válvula 2', 'source': 'LPGD' },
          { 'id': 'LPGD-V3', 'nombre': 'Válvula 3', 'source': 'LPGD' },
          { 'id': 'LPGD-V4', 'nombre': 'Válvula 4', 'source': 'LPGD' },
          { 'id': 'LPGD-V5', 'nombre': 'Válvula 5', 'source': 'LPGD' },
          { 'id': 'LPGD-V6', 'nombre': 'Válvula 6', 'source': 'LPGD' },
          { 'id': 'LPGD-V7', 'nombre': 'Válvula 7', 'source': 'LPGD' },
          { 'id': 'LPGD-V8', 'nombre': 'Válvula 8', 'source': 'LPGD' },
          { 'id': 'LPGD-V9', 'nombre': 'Válvula 9', 'source': 'LPGD' },
          { 'id': 'LPGD-V10', 'nombre': 'Válvula 10', 'source': 'LPGD' },
          { 'id': 'LPGD-V11', 'nombre': 'Válvula 11', 'source': 'LPGD' },
          { 'id': 'LPGD-V12', 'nombre': 'Válvula 12', 'source': 'LPGD' },
          { 'id': 'LPGD-V13', 'nombre': 'Válvula 13', 'source': 'LPGD' },
          { 'id': 'LPGD-V14', 'nombre': 'Válvula 14', 'source': 'LPGD' },
          { 'id': 'LPGD-V15', 'nombre': 'Válvula 15', 'source': 'LPGD' },
          { 'id': 'LPGD-V16', 'nombre': 'Válvula 16', 'source': 'LPGD' },
          { 'id': 'LPGD-V17', 'nombre': 'Válvula 17', 'source': 'LPGD' },
          { 'id': 'LPGD-V18', 'nombre': 'Válvula 18', 'source': 'LPGD' },
          { 'id': 'LPGD-V19', 'nombre': 'Válvula 19', 'source': 'LPGD' },
          { 'id': 'LPGD-V20', 'nombre': 'Válvula 20', 'source': 'LPGD' },
          { 'id': 'LPGD-V21', 'nombre': 'Válvula 21', 'source': 'LPGD' },
          { 'id': 'LPGD-V22', 'nombre': 'Válvula 22', 'source': 'LPGD' },
          { 'id': 'LPGD-V23', 'nombre': 'Válvula 23', 'source': 'LPGD' },
          { 'id': 'LPGD-V24', 'nombre': 'Válvula 24', 'source': 'LPGD' },
          { 'id': 'LPGD-V25', 'nombre': 'Válvula 25', 'source': 'LPGD' },
          { 'id': 'LPGD-V26', 'nombre': 'Válvula 26', 'source': 'LPGD' },
          { 'id': 'LPGD-V1B', 'nombre': 'Válvula 1 BIS', 'source': 'LPGD' },
          { 'id': 'LPGD-V2B', 'nombre': 'Válvula 2 BIS', 'source': 'LPGD' },
          { 'id': 'LPGD-V3B', 'nombre': 'Válvula 3 BIS', 'source': 'LPGD' },
          { 'id': 'LPGD-V4B', 'nombre': 'Válvula 4 BIS', 'source': 'LPGD' },
          { 'id': 'LPGD-V5B', 'nombre': 'Válvula 5 BIS', 'source': 'LPGD' },
          { 'id': 'LPGD-INT', 'nombre': 'Interconexión', 'source': 'LPGD' },
          { 'id': 'TPA-RV', 'nombre': 'Recuperador de vapores', 'source': 'TPA'},
          { 'id': 'TPA-PM', 'nombre': 'Paquete de Medición', 'source': 'TPA'},
          { 'id': 'TPA-BP', 'nombre': 'Bombas de Proceso', 'source': 'TPA'},
          { 'id': 'TPA-SISV', 'nombre': 'Sistema Vickers', 'source': 'TPA'},
          { 'id': 'TPA-SCI', 'nombre': 'Sist. Contra Incendio', 'source': 'TPA'},
          { 'id': 'TPA-CB', 'nombre': 'Cuarto de Baterias', 'source': 'TPA'},
          { 'id': 'EB00-BP', 'nombre': 'Bombas de Proceso', 'source': 'EB00'},
          { 'id': 'EB00-CB', 'nombre': 'Cuarto de Baterias', 'source': 'EB00'},
          { 'id': 'EB00-PM', 'nombre': 'Patín de Medición', 'source': 'EB00'},
          { 'id': 'EB00-TD', 'nombre': 'Trampa de Diablos', 'source': 'EB00'},
          { 'id': 'EB00-TR', 'nombre': 'Tren de Regulación', 'source': 'EB00'},
          { 'id': 'ERM-PM', 'nombre': 'Patín de Medición', 'source': 'ERM'},
          { 'id': 'ERM-SAL', 'nombre': 'Salida IRGE', 'source': 'ERM'},
          { 'id': 'ERM-TD', 'nombre': 'Trampa de Diablos', 'source': 'ERM'},
          { 'id': 'ERM-TP', 'nombre': 'Tanque Pulmón', 'source': 'ERM'},
          { 'id': 'ERM-TPRG', 'nombre': 'Tanque de Purga', 'source': 'ERM'},
          { 'id': 'ERM-TR', 'nombre': 'Tren de Regulación', 'source': 'ERM'},
          { 'id': 'ERM-JEF', 'nombre': 'Jefatura', 'source': 'ERM'},
          { 'id': 'ERM-COM', 'nombre': 'Comedor', 'source': 'ERM'},
          { 'id': 'ERM-CEL', 'nombre': 'Cuarto Eléctrico', 'source': 'ERM'},
          { 'id': 'EB04-BP', 'nombre': 'Bombas de Proceso', 'source': 'EB04'},
          { 'id': 'EB04-CAB', 'nombre': 'Cabezales', 'source': 'EB04'},
          { 'id': 'EB04-CB', 'nombre': 'Cobertizo de Bombas', 'source': 'EB04'},
          { 'id': 'EB04-COC', 'nombre': 'Cocina', 'source': 'EB04'},
          { 'id': 'EB04-CTE', 'nombre': 'Cuarto Eléctrico', 'source': 'EB04'},
          { 'id': 'EB04-GEN', 'nombre': 'Generadores', 'source': 'EB04'},
          { 'id': 'EB04-PM', 'nombre': 'Patín de Medición', 'source': 'EB04'},
          { 'id': 'EB04-RP', 'nombre': 'Residuos Peligrosos', 'source': 'EB04'},
          { 'id': 'EB04-TALL', 'nombre': 'Taller y Almacén', 'source': 'EB04'},
          { 'id': 'EB04-TD', 'nombre': 'Trampa de Diablos', 'source': 'EB04'},
          { 'id': 'EB04-TORG', 'nombre': 'Tanque de Purga', 'source': 'EB04'},
          { 'id': 'EB04-TR', 'nombre': 'Tren de Regulación', 'source': 'EB04'},
          { 'id': 'EB04-TRA', 'nombre': 'Transformador', 'source': 'EB04'},
          { 'id': 'IRGE-BOM', 'nombre': 'Bombas LPG', 'source': 'IRGE'},
          { 'id': 'IRGE-BP', 'nombre': 'Bombas de Proceso', 'source': 'IRGE'},
          { 'id': 'IRGE-CB', 'nombre': 'Cuarto de Bombas', 'source': 'IRGE'},
          { 'id': 'IRGE-CCM', 'nombre': 'CCM', 'source': 'IRGE'},
          { 'id': 'IRGE-CI', 'nombre': 'Red C.I.', 'source': 'IRGE'},
          { 'id': 'IRGE-COMP', 'nombre': 'Area de Compresores', 'source': 'IRGE'},
          { 'id': 'IRGE-CONT', 'nombre': 'Contabilidad', 'source': 'IRGE'},
          { 'id': 'IRGE-CUB', 'nombre': 'Cubeta', 'source': 'IRGE'},
          { 'id': 'IRGE-ESF', 'nombre': 'Esferas', 'source': 'IRGE'},
          { 'id': 'IRGE-LLEN', 'nombre': 'Llenaderas', 'source': 'IRGE'},
          { 'id': 'IRGE-MANT', 'nombre': 'Of. Mantenimiento', 'source': 'IRGE'},
          { 'id': 'IRGE-PROP', 'nombre': 'Of. Propangol', 'source': 'IRGE'},
          { 'id': 'IRGE-TA', 'nombre': 'Tanque de Agua', 'source': 'IRGE'},
          { 'id': 'IRGE-TD', 'nombre': 'Trampa de Diablos', 'source': 'IRGE'},
          { 'id': 'IRGE-TP', 'nombre': 'Tanque Pulmón', 'source': 'IRGE'},
          { 'id': 'IRGE-TR', 'nombre': 'Tren de Regulación', 'source': 'IRGE'},
          { 'id': 'IRGE-TRA', 'nombre': 'Area de Trasiegos', 'source': 'IRGE'},
          { 'id': 'IRGE-TALL', 'nombre': 'Taller', 'source': 'IRGE'},
          { 'id': 'REM', 'nombre': 'Remoto', 'source': 'REM'},
        ],
        oficinasSel: [],
        isDisabled: true,
        isCompleto: false,
        isEqualsPass: false
      }
    },
    watch: {
      user () {
        this.resultConfirm()

      },
      'user.nombre' (newValue, oldValue) {
        this.checkComplete()
      },

      'user.password' (newValue, oldValue) {
        this.checkComplete()
      },
      'user.password_confirm' (newValue, oldValue) {
        this.checkComplete()
      },
      'user.categoria' (newValue, oldValue) {
        this.checkComplete()
      },
      'user.departamento' (newValue, oldValue) {
        this.checkComplete()
      },
      'user.cargo' (newValue, oldValue) {
        this.checkComplete()
      },
      'user.ubicacion' (newValue, oldValue) {
        this.oficinasSel = this.oficinas.filter( ofi => ofi.source === this.user.ubicacion)
        this.checkComplete()
      },
      'user.email' (newValue, oldValue) {
        this.checkComplete()
      },

      'user.departamento' (newValue, oldValue) {
        this.cargosSelected = this.cargos.filter(cargo => cargo.parent === newValue)
        this.checkComplete()
        
      },
      'user.nombre_completo' (newValue, oldValue) {
        let nombreSplit = newValue.split(" ")
        let text = ''
        nombreSplit.forEach(element => {
          text += `${element}_`
        })
        let finalText = text.substring(0, text.length -1 )
        this.user.nombre_file = finalText
        this.checkComplete()
      }
    },
    methods: {
      iniciarComponente () {
        setTimeout(() => {
          this.isLoading = false
        }, 250)
      },
      resultConfirm () {
        if (this.user.password === '' || this.user.password_confirm === '') {
          this.isEqualsPass = false
          return ''
        } else {
          if (this.user.password === this.user.password_confirm ) {
            this.isEqualsPass = true
            return `<span class="icon has-text-success is-large">
              <i class="fas fa-2x fa-check-circle"></i>
              </span>`
          } else {
            this.isEqualsPass = false
            return `<span class="icon has-text-danger is-large">
              <i class="fas fa-2x fa-exclamation-circle"></i>
              </span>`
          }
        }
      },
      guardarUsuario () {
        this.isLoading = true
        if (this.user.categoria === '2') {
          this.user.jefe = '1'
        } else {
          this.user.jefe = '0'
        }
        this.user.id = Date.now()
        this.user.fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
        
        usuariosServices.addUser(this.user.id, this.user.nombre, this.user.nombre_completo, this.user.nombre_file, this.user.password, this.user.categoria, this.user.departamento, this.user.cargo, this.user.jefe, this.user.ubicacion, this.user.oficina, this.user.fechaReg, this.user.email, '')
          .then(res => {
            console.log(res)
              this.isLoading = false
            if (res.success) {
              setTimeout(() => {
                this.isLoading = false
                this.$router.push({ path: `/Usuario/Detalle/${this.user.id}` })
              }, 250)
            } else {
              
            }
          })
      },
      checkComplete () {
        let complete = this.user.nombre.length * this.user.nombre_completo.length * this.user.categoria.length * this.user.departamento.length * this.user.cargo.length * this.user.email.length * this.user.ubicacion.length
        console.log(complete)
        if (complete > 0) {

          if (this.isEqualsPass) {
            this.isDisabled = false
          } else {
            this.isDisabled = true
          }
        } else {
          this.isDisabled = true
        }
      }
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>


<style lang="css" scoped>
  .container {
    padding: 40px 0;
  }

  .column-blanco {
    padding-bottom: 120px;
  }
</style>




// WEBPACK FOOTER //
// src/components/usuarios_Componentes/usuario_Nuevo.vue